import styled from "styled-components";

export const Pill = styled.div`
    display: flex;
    flex: 0;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    align-self: flex-start;
    padding: 0rem 0.5rem;
    color: #fff;
    background: #000;
    border-radius: 1rem;
    border: 1px solid #000;
    `

export const SuccessPill = styled(Pill)`
    background: #07bc0c;
    border: 1px solid #07bc0c;

`